import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['progressCircle', 'progressCircleAnimated'];

  connect() {
    this.animatedProgress();
  }

  animatedProgress() {
    const percent = this.progressCircleTarget.dataset.countervalue;
    const radius = this.progressCircleAnimatedTarget.getAttribute('r');
    const circumference = 2 * Math.PI * radius;
    const strokeDashOffset = circumference - (percent * circumference) / 100;

    this.progressCircleAnimatedTarget.removeAttribute('style');

    this.progressCircleAnimatedTarget.animate(
      [{ strokeDashoffset: strokeDashOffset, stroke: '#305348' }],
      {
        duration: 500,
        fill: 'forwards',
      }
    );
  }
}
